// extracted by mini-css-extract-plugin
module.exports = {"loaderSection":"loading_loaderSection__3D-ev"};